// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2vAIU","disabled":"FileBtn_disabled__1rSnp","warn":"FileBtn_warn__2ojVx","fade":"FileBtn_fade__1O8wt"};